// Display helpers and brand-consistent chip styling.

export const QUALITY_STYLES = {
  Ace: "bg-emerald-50 text-emerald-700 border-emerald-200",
  King: "bg-blue-50 text-blue-700 border-blue-200",
  Queen: "bg-violet-50 text-violet-700 border-violet-200",
  Joker: "bg-red-50 text-red-600 border-red-200",
};

export const QUALITY_DOT = {
  Ace: "bg-emerald-500",
  King: "bg-blue-500",
  Queen: "bg-violet-500",
  Joker: "bg-red-500",
};

export const STAGE_STYLES = {
  "New Lead": "bg-sky-50 text-sky-700 border-sky-200",
  "Call Not Picked": "bg-amber-50 text-amber-700 border-amber-200",
  "Call Back Later": "bg-orange-50 text-orange-700 border-orange-200",
  Qualified: "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Meeting Scheduled": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "Proposal Sent": "bg-violet-50 text-violet-700 border-violet-200",
  Negotiation: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  Won: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Lost: "bg-red-50 text-red-600 border-red-200",
  Junk: "bg-slate-100 text-slate-500 border-slate-200",
  Nurture: "bg-teal-50 text-teal-700 border-teal-200",
};

export function fmtDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
}

export function fmtRelative(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";
  const diff = d.getTime() - Date.now();
  const days = Math.round(diff / 86400000);
  if (days === 0) return "Today";
  if (days === 1) return "Tomorrow";
  if (days === -1) return "Yesterday";
  if (days < 0) return `${Math.abs(days)}d overdue`;
  return `In ${days}d`;
}

// Notification timestamp: "just now" / "Xm ago" up to 1 hour, then the exact
// time. Same-day shows the clock time (e.g. "2:45 PM"); older shows date + time
// (e.g. "Jun 10, 2:45 PM"). Adds the year only when it differs from the current.
export function fmtNotifTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";
  const secs = Math.floor((Date.now() - d.getTime()) / 1000);
  if (secs < 60) return "just now";
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const now = new Date();
  const time = d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  if (d.toDateString() === now.toDateString()) return time;
  const sameYear = d.getFullYear() === now.getFullYear();
  const date = d.toLocaleDateString(undefined, { month: "short", day: "numeric", ...(sameYear ? {} : { year: "numeric" }) });
  return `${date}, ${time}`;
}

export function isOverdue(value) {
  if (!value) return false;
  return new Date(value).getTime() < Date.now();
}

// Compact "lead age" since a creation timestamp, e.g. "3d", "5h", "just now".
export function ageSince(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";
  const mins = Math.max(0, Math.floor((Date.now() - d.getTime()) / 60000));
  if (mins < 60) return mins <= 1 ? "just now" : `${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h`;
  const days = Math.floor(hrs / 24);
  return `${days}d`;
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
}

export function fmtINR(n) {
  const num = Number(n) || 0;
  if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
  return `₹${num.toLocaleString("en-IN")}`;
}
